import React, { Fragment } from "react";
import "./WebChatHeader.css";
import { css } from "glamor";
import chatLogo from "../../assets/images/user.png";
import backImg from "../../assets/images/back.svg";
import refreshImg from "../../assets/images/refresh.svg";
import minimizeImg from "../../assets/images/minimize.svg";
import QueueWaiting from "../QueueWaitingComponent/QueueWaitingComponent";
import closeIcon from "../../assets/images/icons8-close.svg";
import minusIcon from "../../assets/images/minus.png";
const WebChatHeader = (props) => {
  const headerStyle = css({
    // display: 'none',
    paddingRight: "0px",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    // weight: '95%',
    marginBottom: "20px",
    //background: props.webChatConfiguration.headerBackground ? props.webChatConfiguration.headerBackground : "linear-gradient(to right, #1e92b8, #295897, #1f356f)",
    minHeight: props.webChatConfiguration.headerMinHeight
      ? props.webChatConfiguration.headerMinHeight
      : "12%",
    maxHeight: props.webChatConfiguration.headerMaxHeight
      ? props.webChatConfiguration.headerMaxHeight
      : "15%",
    backgroundImage: props.webChatConfiguration.headerBackgroundImage
      ? props.webChatConfiguration.headerBackgroundImage
      : "linear-gradient(to right,#0064bd, #007a9f, #0300a6, #055fac, #3911b3)",
  });

  const headerTitle = css({
    flex: 0,
    // marginLeft: props.language.indexOf('ar') >= 0 ? '0%' : '5%',
    // marginRight: props.language.indexOf('ar') >= 0 ? '5%' : '0%',
    marginLeft: props.language.indexOf("ar") >= 0 ? "0%" : "5%",
    marginRight: props.language.indexOf("ar") >= 0 ? "5%" : "0%",
    "& .header-text": {
      color: props.webChatConfiguration.headerTextColor
        ? props.webChatConfiguration.headerTextColor
        : "#fff",
    },
    "& #header-text-en": {
      fontSize: props.webChatConfiguration.headerTextEnglishFontSize
        ? props.webChatConfiguration.headerTextEnglishFontSize
        : "2vh",
      fontWeight: props.webChatConfiguration.headerTextEnglishFontWeight
        ? props.webChatConfiguration.headerTextEnglishFontWeight
        : "300 !important",
      height: props.webChatConfiguration.headerTextEnglishHeight
        ? props.webChatConfiguration.headerTextEnglishHeight
        : "50%",
      lineHeight: props.webChatConfiguration.headerTextLineHeight
        ? props.webChatConfiguration.headerTextLineHeight
        : "200%",
    },
    "& #header-text-ar": {
      fontFamily: props.webChatConfiguration.headerTextArabicFontFamily
        ? props.webChatConfiguration.headerTextArabicFontFamily
        : "Arabic medium",
      height: props.webChatConfiguration.headerTextArabicHeight
        ? props.webChatConfiguration.headerTextArabicHeight
        : "50%",
      lineHeight: props.webChatConfiguration.headerTextArabicLineHeight
        ? props.webChatConfiguration.headerTextArabicLineHeight
        : "250%",
    },
    "& #header-text-hadi": {
      fontFamily: props.webChatConfiguration.headerTextHadiFontFamily
        ? props.webChatConfiguration.headerTextHadiFontFamily
        : "DUBAI-REGULAR",
      fontSize: props.webChatConfiguration.headerTextHadiFontSize
        ? props.webChatConfiguration.headerTextHadiFontSize
        : "3.5vh",
      height: props.webChatConfiguration.headerTextHadiFontSize
        ? props.webChatConfiguration.headerTextHadiFontSize
        : "50%",
      lineHeight: props.webChatConfiguration.headerTextHadiLineHeight
        ? props.webChatConfiguration.headerTextHadiLineHeight
        : "250%",
    },
  });

  const logoPath = props.webChatConfiguration.webChatLogoPath
    ? props.webChatConfiguration.webChatLogoPath
    : "images/newLogo.gif";

  const logoStyle = css({
    // height: '0px !important',
    width: props.showWebChatLogoPath
      ? props.webChatConfiguration.logoWidth
        ? props.webChatConfiguration.logoWidth
        : "auto"
      : "0px !important",
    height: props.webChatConfiguration.logoHeight
      ? props.webChatConfiguration.logoHeight
      : "9vh",
    margin: props.webChatConfiguration.logoMargin
      ? props.webChatConfiguration.logoMargin
      : "auto",
    padding: props.webChatConfiguration.logoPadding
      ? props.webChatConfiguration.logoPadding
      : "10% 8%",
  });

  const soundButtonStyle = css({
    backgroundImage: `url(../../assets/${
      !props.soundMuted
        ? props.webChatConfiguration.headerSoundButtonBackgroundImage
          ? props.webChatConfiguration.headerSoundButtonBackgroundImage
          : "images/sound-icon.png"
        : props.webChatConfiguration.headerSoundMutedButtonBackgroundImage
        ? props.webChatConfiguration.headerSoundMutedButtonBackgroundImage
        : "images/sound-icon.png-muted"
    })`,
  });

  const restartButtonStyle = css({
    backgroundImage: `url(../../assets/${
      props.webChatConfiguration.headerRestartButtonBackgroundImage
        ? props.webChatConfiguration.headerRestartButtonBackgroundImage
        : "images/restartButton.png"
    })`,
  });

  const backButtonStyle = css({
    // backgroundImage: `url(../../assets/${props.webChatConfiguration.headerBackButtonBackgroundImage ?
    // 	props.webChatConfiguration.headerBackButtonBackgroundImage :
    // 	'images/back.png'})`,
    marginTop: "1em",
    marginLeft: "1em",
    display: "inline-flex",
  });

  const expandButtonStyle = css({
    backgroundImage: `url(../../assets/${
      props.webChatConfiguration.headerExpandButtonBackgroundImage
        ? props.webChatConfiguration.headerExpandButtonBackgroundImage
        : "images/expand-icon.png"
    })`,
  });

  const closeButtonStyle = css({
    backgroundImage: `url(../../assets/${
      props.webChatConfiguration.headerCloseButtonBackgroundImage
        ? props.webChatConfiguration.headerCloseButtonBackgroundImage
        : "images/close-icon.png"
    })`,
  });

  let expandOrClose;

  window.addEventListener(
    "Queued",
    (e) => {
      e.preventDefault();
      console.log("data 'e.detail' from Queued Header ", e.detail);
    },
    false
  );

  let isClose =
    props.size.width < props.size.height ||
    (props.size.height < 500 &&
      window.matchMedia("(orientation: portrait)").matches);
  let headerContainerClass = "header-button-container ";
  if (isClose) {
    expandOrClose = (
      <div
        className={`${closeButtonStyle} header-button`}
        onClick={props.onCloseButtonClicked}
      ></div>
    );
    headerContainerClass += "big-header-button-container";
  } else {
    expandOrClose = (
      <div
        className={`${expandButtonStyle} header-button`}
        onClick={props.onWindowChangedHeight}
      ></div>
    );
    headerContainerClass += "small-header-button-container";
  }
  // let needHelpText = props.language.indexOf('ar') >=0 ? "تحتاج مساعدة؟" : "Need help?"
  const chatHeaderTitle =
    props.language.indexOf("ar") >= 0
      ? "خالد - مساعدك الافتراضي "
      : "Khaled – Your Virtual Assistant";
  const chatHeaderText = props.language.indexOf("ar") >= 0 ? "راشد" : "Rashid";

  const isQueueWaitingVisiable =
    props.queueData && props.queueData.QueuePosition > 0 ? true : false;

  return (
    <Fragment>
      <div
        className={`rdhelp-header ${isQueueWaitingVisiable ? "showQueue" : ""}`}
      >
        {!isQueueWaitingVisiable ? (
          <Fragment>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="rdhelp-back" style={{ alignItems: "center" }}>
                  <img src={chatLogo} className="logo" />
                </div>
                <div className="text">
                  <h4 style={{ fontWeight: "bold", color: "white" }}>
                    {chatHeaderTitle}
                    {/* Khaled – Your Virtual Assistant */}
                  </h4>
                  {/* <p>{chatHeaderText}</p> */}
                </div>
              </div>

              <div>
                <img
                  onClick={() => window.parent.postMessage("minusIframe", "*")}
                  src={minusIcon}
                  id="minusimage"
                  style={{
                    width: "20px",
                    marginInline: "10px",
                    cursor: "pointer",
                  }}
                />
                <img
                  onClick={() => window.parent.postMessage("closeIframe", "*")}
                  src={closeIcon}
                  style={{
                    width: "20px",
                    marginInline: "10px",
                    cursor: "pointer",
                  }}
                />
              </div>
            </div>
          </Fragment>
        ) : (
          <QueueWaiting queueData={props.queueData} />
        )}

        <span className="space"></span>
        {/* <div className="line">
          <div className="icons">
            <div
              className="icon send"
              onClick={props.onSendTranscriptButtonClicked}
            >
              <i className="fa fa-envelope"></i>
              <span className="tooltip">
                {props.language.indexOf("ar") >= 0
                  ? "إرسال نص المحادثة"
                  : "Send Transcript"}
              </span>
            </div>
            <span className="icon" onClick={props.onBackButtonClicked}>
              <img src={backImg} />
              <span className="tooltip">
                {props.language.indexOf("ar") >= 0 ? "بدء المحادثة" : "Restart"}
              </span>
            </span>
            <span className="icon" onClick={props.onRestartButtonClicked}>
              <img src={refreshImg} />
              <span className="tooltip">
                {props.language.indexOf("ar") >= 0 ? "تحديث" : "Refresh"}
              </span>
            </span>
            <span className="icon" onClick={props.onCloseButtonClicked}>
              <img src={minimizeImg} />
              <span className="tooltip">
                {props.language.indexOf("ar") >= 0 ? "تمديد" : "Expand"}
              </span>
            </span>
          </div>
        </div> */}
      </div>
      <header style={{ display: "none" }} className={`${headerStyle} `}>
        <div className="header-container-right">
          <div className="header-buttons">
            {/* TODO: Change logo and set max-width as configurable */}
            <div
              className={headerContainerClass}
              style={{
                display: props.webChatConfiguration.headerShowSoundBackButton
                  ? "block"
                  : "none",
              }}
            >
              <div
                className={`${soundButtonStyle} header-button`}
                onClick={props.onToggleMuteSound}
              ></div>
            </div>
            <div className={headerContainerClass} style={{ display: "block" }}>
              {/* props.webChatConfiguration.headerShowBackButton ? "block" : "none" }}> */}
              <div
                className={`${backButtonStyle} header-button back`}
                onClick={props.onBackButtonClicked}
              >
                {/* <img className="back-image" src={require('../../assets/images/back.png')} alt="Back Button" /> */}
                <span className="back-text">Back</span>
              </div>
            </div>
            <div
              className={headerContainerClass}
              style={{
                display: props.webChatConfiguration.headerShowRestartBackButton
                  ? "block"
                  : "none",
              }}
            >
              <div
                className={`${restartButtonStyle} header-button`}
                onClick={props.onRestartButtonClicked}
              ></div>
            </div>
            <div
              className={headerContainerClass}
              style={{
                display: props.webChatConfiguration.headerShowExpandBackButton
                  ? "block"
                  : "none",
              }}
            >
              {expandOrClose}
            </div>
          </div>
          {/* style={{ display: props.webChatConfiguration.headerContainerRight.showSelectLanguageDropdown ? "block" : "none" }} */}
          <div
            className="select-language"
            style={{
              display: props.webChatConfiguration.headerShowMultilingualButton
                ? "block"
                : "none",
            }}
            onChange={props.onSelectLanguageChanged}
          >
            <select name="languages">
              <option value="en-us">English</option>
              <option value="ar-SA">Arabic</option>
              <option value="zh-Hans">China</option>
              <option value="hi">Hindi</option>
              <option value="tr">Turkish</option>
              <option value="it">Italian</option>
              <option value="fr">French</option>
            </select>
          </div>
        </div>
        <div className="talking-avatar">
          {/* <img className="mini-image" src={require('../../assets/images/minimize.png')} alt="Mini " /> */}
        </div>
      </header>
    </Fragment>
  );
};

export default WebChatHeader;
